import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { GetBanner, EditBanner } from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import InputColor from "react-input-color";
import axios from "axios";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class EditGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      bannertitle: "",
      bannertitleError: null,
      banner_icon_url: "",
      banner_icon_urlError: null,
      oldbannerIconfile: "",
      banner_icon: "",
      banner_icon_data: "",
      errormessages: [],
      banner_icon_err: "",
      is_changed: false,
      is_featured: "2",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handlebanner_iconFileChange =
      this.handlebanner_iconFileChange.bind(this);
  }

  handlebanner_iconFileChange(event) {
    var size = event.target.files[0].size;
    var type = event.target.files[0].type;
    if (type == "image/png" || type == "image/jpg" || type == "image/jpeg") {
      if (size > 2000000) {
        this.setState({
          banner_icon_err: (
            <small className="text-danger">
              Image file size should be less than 2MB.
            </small>
          ),
        });
      } else {
        var file = event.target.files[0];
        var url = URL.createObjectURL(file);
        this.setState({
          banner_icon: event.target.files[0],
          oldbannerIconfile: url,
          banner_icon_err: "",
          is_changed: true,
        });
      }
    } else {
      this.setState({
        banner_icon_err: (
          <small className="text-danger">File type is invalid</small>
        ),
      });
    }
  }

  uploadbanner_icon() {
    document.getElementById("selectbanner_icon").click();
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Banner</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 3,
    });
    setTimeout(() => {
      this.props.history.push("/admin/banner");
    }, 3000);
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var oldid = JSON.parse(localStorage.getItem("bannerID"));

    GetBanner(obj, oldid).then((res) => {
      const data = res.data;

      var is_featured = "";
      if (data.is_featured == "1") {
        is_featured = "1";
      } else if (data.is_featured == "0") {
        is_featured = "2";
      }

      this.setState({
        bannertitle: data.title,
        banner_icon: data.banner_url,
        oldbannerIconfile: data.banner_url,
        is_featured: is_featured,
      });
      console.log(data.banner_url);
    });
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.banner_icon.length == 0) {
      error = true;
      this.setState({
        banner_icon_err: (
          <small className="text-danger">Please select banner image.</small>
        ),
      });
    } else {
      this.setState({ banner_icon_err: "" });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }

      var id = JSON.parse(localStorage.getItem("bannerID"));
      this.setState({ processing: true });
      if (this.state.is_changed) {
        const fdata = new FormData();
        fdata.append("banner_file", this.state.banner_icon);
        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/banner/image";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            if (res.data.success == true) {
              EditBanner(
                obj,
                id,
                this.state.bannertitle,
                res.data.data.banner_url,
                is_featured,
              )
                .then((res) => {
                  if (res.success === false) {
                    let message = res.data.data;
                    this.handleClick("bl", message);
                  } else if (res.success === true) {
                    this.handleSuccess("bl");
                  }
                })
                .catch((error) => {
                  this.handleNetworkError("bl", error);
                });
            } else {
              var icondata = this.state.oldbannerIconfile;
              EditBanner(obj, id, this.state.bannertitle, icondata, is_featured)
                .then((res) => {
                  if (res.success === false) {
                    let message = res.data.data;
                    this.handleClick("bl", message);
                  } else if (res.success === true) {
                    this.handleSuccess("bl");
                  }
                })
                .catch((error) => {
                  this.handleNetworkError("bl", error);
                });
            }
          })
          .catch((error) => {
            this.handleNetworkError("bl", error);
          });
      } else {
        EditBanner(
          obj,
          id,
          this.state.bannertitle,
          this.state.oldbannerIconfile,
          is_featured,
        )
          .then((res) => {
            if (res.success === false) {
              let message = res.data.data;
              this.handleClick("bl", message);
            } else if (res.success === true) {
              this.handleSuccess("bl");
            }
          })
          .catch((error) => {
            this.handleNetworkError("bl", error);
          });
      }
    }
  }

  handleDateChange = (date) => {
    this.setState({
      startdate: date,
    });
  };

  handleEndDateChange = (date) => {
    this.setState({
      enddate: date,
    });
  };

  setColor = (colors) => {
    this.setState({
      background_color: colors,
    });
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Card
            content={
              <form>
                {errormessages.length != 0 && (
                  <div className=" alert alert-danger">
                    {errormessages.map((data) => (
                      <React.Fragment>
                        <li>{data}</li>
                      </React.Fragment>
                    ))}
                  </div>
                )}
                <Row>
                  <Col sm={12} md={6}>
                    <FormGroup>
                      <ControlLabel>Title</ControlLabel>
                      <FormControl
                        style={{ margin: "0" }}
                        name="bannertitle"
                        value={this.state.bannertitle}
                        onChange={(event) => {
                          this.setState({ bannertitle: event.target.value });
                        }}
                        placeholder="Enter Banner Title"
                        type="text"
                      />
                      {this.state.bannertitleError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                      <div className="alter_xeroInv">
                        <Radio
                          number="16"
                          option="1"
                          name="is_featured"
                          onChange={this.onChange}
                          checked={this.state.is_featured === "1"}
                          label="Yes"
                        />
                        <Radio
                          number="17"
                          option="2"
                          name="is_featured"
                          onChange={this.onChange}
                          checked={this.state.is_featured === "2"}
                          label="No"
                        />
                      </div>
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Upload Icon</ControlLabel>
                      <br></br>

                      <input
                        style={{ display: "none" }}
                        id="selectbanner_icon"
                        type="file"
                        className="form-control"
                        name="banner_icon"
                        onChange={this.handlebanner_iconFileChange}
                      />
                      <div className="banneruploadicon">
                        <div className="previewwithbutton">
                          <Button
                            onClick={this.uploadbanner_icon}
                            style={{ color: "#2B3A41", width: "fit-content" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.banner_icon == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.banner_icon == ""
                              ? "Choose Banner Image"
                              : "Change Banner Image"}
                          </Button>
                        </div>

                        {this.state.oldbannerIconfile.length > 0 && (
                          <div className="preview_banner_image">
                            <ControlLabel>Preview</ControlLabel>
                            <a
                              target="_blank"
                              href={this.state.oldbannerIconfile}
                            >
                              {this.state.is_changed ? (
                                <img src={this.state.oldbannerIconfile} />
                              ) : (
                                <embed
                                  src={this.state.oldbannerIconfile}
                                  width="100%"
                                  height="100%"
                                />
                              )}
                            </a>
                            <br></br>
                          </div>
                        )}

                        {this.state.banner_icon_err}
                      </div>
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </form>
            }
          />
        </Grid>
      </div>
    );
  }
}

export default EditGroup;
